export default __webpack_public_path__ + "static/media/portfolio-50.ff063fc5.jpg";